export const QUALIFICATION_STATUS_LABELS = {
  missing: 'Missing', pending: 'Awaiting review', rejected: 'Changes requested',
  current: 'Current', expiring: 'Expiring soon', expired: 'Expired',
};
export function qualificationStatus(record, today = new Date().toISOString().slice(0, 10)) {
  if (!record?.status) return 'missing';
  if (record.status === 'pending') return 'pending';
  if (record.status === 'rejected') return 'rejected';
  if (record.status !== 'approved') return 'missing';
  if (record.expiresOn) {
    if (record.expiresOn < today) return 'expired';
    const days = (Date.parse(`${record.expiresOn}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86400000;
    if (days <= 30) return 'expiring';
  }
  return 'current';
}
